import { css } from '@emotion/css';
import React from 'react';
import { useTranslation } from 'react-i18next';

export const NoUserProfile: React.FC = () => {
  const { t } = useTranslation('fortune');
  return (
    <div
      className={css`
        color: #938666;
        max-width: 480px;
        margin: 0 auto;
        padding: 20px;
        h3 {
          text-align: center;
          margin: 0 0 12px;
        }
      `}
    >
      <h3>{t('error_cannot_get_point')}</h3>
      <p>{t('error_cannot_get_point_desc')}</p>
    </div>
  );
};
